import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { RoleAccess } from '../../../models/role-access.model';
import { UserProfile } from '../../../models/user-profile.model';
import { UserData } from '../../../providers/user-data';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UtilService } from '../../../service/util.service';
import { TierService } from '../tier.service';
import { MyService } from '../../../service/my.service';

@Component({
  selector: 'app-tier-form',
  templateUrl: './tier-form.page.html',
  styleUrls: ['./tier-form.page.scss'],
})
export class TierFormPage implements OnInit {

  action:any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  formTier: FormGroup;
  tierId:any;
  maxDate: string;
  customerItem:any[]=[];
  emailTemplate:any[]=[];
  constructor(
    private activeRoute: ActivatedRoute,
    private userData: UserData,
    private toastCtrl : ToastController,
    private navCtrl : NavController,
    private alertController : AlertController,
    private storage: Storage,
    private router: Router,
    private fb: FormBuilder,
    private utilService:UtilService,
    private tierService:TierService,
    private myService:MyService
  ) { }

  ngOnInit() {  
    this.setMaxDate();
    this.buildFormTier();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        } 
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildFormTier() {
    this.formTier = this.fb.group({
      tierName: [null],
      spendToReach: [0],
      spendToKeep: [0],
      redeemPercent: [1,[Validators.min(1), Validators.max(100)]],
      activeFlag: ['Y'],
      benefit:this.fb.array([]),
    });
  }
  getData() {
    this.customerItem = [];
    this.emailTemplate = [];
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.action = AES.decrypt(snapshot.a, myKey).toString(utf8);
      this.tierId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      if(this.action!='adds'){
        let option={
          "token": this.token,
          "id":this.tierId,
          "username":this.userProfile.username
        };
        this.tierService.getTier(option)
        .subscribe((response: any) => {
          let rs = response.results.data;
          console.log(response);
          this.customerItem = response.results.customer_item;
          this.emailTemplate = response.results.email_template;
          let spend_to_reach = rs!=null ? parseFloat(rs.spend_to_reach).toFixed(0) :'0';
          spend_to_reach = this.myService.separator(spend_to_reach);
          spend_to_reach = String(spend_to_reach).replace(/[^0-9.,]/g, '');
          
          let spend_to_keep = rs!=null ? parseFloat(rs.spend_to_keep).toFixed(0) : '0';
          spend_to_keep = this.myService.separator(spend_to_keep);
          spend_to_keep = String(spend_to_keep).replace(/[^0-9.,]/g, '');
          let redeem_percent = rs!=null ? rs.redeem_percent : 0;
          let tier_name = rs!=null ? rs.tier_name : '';
          let active_flag = rs!=null ? rs.active_flag : 'Y';
          this.formTier.patchValue({
            spendToReach: spend_to_reach,
            spendToKeep: spend_to_keep,
            redeemPercent:redeem_percent,
            tierName: tier_name,
            activeFlag:active_flag
          });
          if(rs!=null && rs.benefit.length>0){
            for(let i=0;i<rs.benefit.length;i++){
              let maximumVoucherValue = parseFloat(rs.benefit[i].maximum_voucher_value).toFixed(0);
              maximumVoucherValue = this.myService.separator(maximumVoucherValue);
              maximumVoucherValue = String(maximumVoucherValue).replace(/[^0-9.,]/g, '');
              let voucherMinSpend = parseFloat(rs.benefit[i].voucher_min_spend).toFixed(0);
              voucherMinSpend = this.myService.separator(voucherMinSpend);
              voucherMinSpend = String(voucherMinSpend).replace(/[^0-9.,]/g, '');
              let benefitValue = parseFloat(rs.benefit[i].benefit_value).toFixed(0);
              benefitValue = this.myService.separator(benefitValue);
              benefitValue = String(benefitValue).replace(/[^0-9.,]/g, '');
              let minSpendOrBring = parseFloat(rs.benefit[i].min_spend_or_bring).toFixed(0);
              minSpendOrBring = this.myService.separator(minSpendOrBring);
              minSpendOrBring = String(minSpendOrBring).replace(/[^0-9.,]/g, '');
              let min_transactions =parseFloat(rs.benefit[i].min_transactions).toFixed(0);
              min_transactions = this.myService.separator(min_transactions);
              min_transactions = String(min_transactions).replace(/[^0-9.,]/g, '');
              rs.benefit[i].benefit_value = benefitValue;
              rs.benefit[i].min_spend_or_bring = minSpendOrBring;
              rs.benefit[i].maximum_voucher_value = maximumVoucherValue;
              rs.benefit[i].voucher_min_spend = voucherMinSpend;
              const detail = this.fb.group({
                benefit_name: rs.benefit[i].benefit_name,
                earn_type: [rs.benefit[i].earn_type],
                item_id:[rs.benefit[i].item_id],
                custom_earn_start_date:[rs.benefit[i].custom_earn_start_date],
                custom_earn_end_date: [rs.benefit[i].custom_earn_end_date],
                benefit_type: [rs.benefit[i].benefit_type],
                min_spend_or_bring: [minSpendOrBring],
                min_transactions:[min_transactions],
                multiple_benefit: [rs.benefit[i].multiple_benefit],
                benefit_value:[benefitValue],
                voucher_earn_time: [rs.benefit[i].voucher_earn_time],
                voucher_start:[rs.benefit[i].voucher_start],
                voucher_expired: [rs.benefit[i].voucher_expired],
                voucher_expired_type: [rs.benefit[i].voucher_expired_type],
                voucher_type:[rs.benefit[i].voucher_type],
                maximum_voucher_value :[rs.benefit[i].maximum_voucher_value],
                voucher_min_spend :[rs.benefit[i].voucher_min_spend],
                voucher_code: [rs.benefit[i].voucher_code],
                email_template: [rs.benefit[i].email_template],
                active_flag :[rs.benefit[i].active_flag]
              }, {
                validators: this.startBeforeEndValidator
              });
              this.getDetailArray.push(detail); }
            }
        });
      }
    });
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onChangePrice(columnname:any){ 
    let cur= this.formTier.getRawValue()[columnname];
    let curWithSeparator='0';
    if(cur!='0' && cur!='' && cur!=null){
      curWithSeparator = this.myService.separator(cur);
      curWithSeparator = String(curWithSeparator).replace(/[^0-9,.]/g, '');
    }
    this.formTier.patchValue({[columnname]:curWithSeparator});
  }
  onChangePrice2(index:any,columnname:any){ 
    let arrform=<FormArray>this.formTier.controls['benefit'];    
    let cur= arrform.controls[index].value[columnname];
    let curWithSeparator='0';
    if(cur!='0' && cur!='' && cur!=null){
      curWithSeparator = this.myService.separator(cur);// parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
      curWithSeparator = String(curWithSeparator).replace(/[^0-9,]/g, '');
    }
    arrform.controls[index].patchValue({[columnname]:curWithSeparator});
  }
  saveTier(){
    const tierData = this.formTier.getRawValue();
    console.log(tierData);
    if(tierData.tierName==0 || tierData.tierName==null){
      alert("Tier Name tidak boleh kosong");
      return;
    }
     if(tierData.redeemPercent==0 || tierData.redeemPercent==null){
      alert("Redeem Percent tidak boleh kosong");
      return;
    }
    if(tierData.benefit.length==0){
      alert("Tier Benefit tidak boleh kosong");
      return;
    }
    let spendToReach= tierData.spendToReach ? this.myService.removeSeparator(tierData.spendToReach) : 0;
    let spendToKeep= tierData.spendToKeep ? this.myService.removeSeparator(tierData.spendToKeep) : 0;
    if(tierData.benefit.length>0){
      const seen = new Set();
      for(let i=0; i<tierData.benefit.length;i++){
        const benefit = tierData.benefit[i];
        const key = `${benefit.benefit_name}-${benefit.earn_type}-${benefit.item_id}
          -${benefit.custom_earn_start_date}-${benefit.custom_earn_end_date}-${benefit.benefit_type}-${benefit.min_spend_or_bring}
          -${benefit.multiple_benefit}-${benefit.benefit_value}-${benefit.voucher_earn_time}
          -${benefit.voucher_start}-${benefit.voucher_expired}-${benefit.voucher_expired_type}-${benefit.voucher_type}
          -${benefit.maximum_voucher_value}-${benefit.voucher_min_spend}-${benefit.active_flag}
          -${benefit.min_transactions}`;

        if (seen.has(key)) {
          this.toastCtrl.create({ duration: 2000, message:'Terdapat data benefit yang duplikat' }).then(t => t.present());
          return; // ⛔ Stop proses submit
        }
        seen.add(key);
        if(benefit.benefit_name=='' || benefit.benefit_name==null){
          alert("Benefit Name tidak boleh kosong");
          return;
        }
        if(benefit.earn_type=='' || benefit.earn_type==null){
          alert("Earn Type tidak boleh kosong");
          return;
        }
        if(benefit.earn_type=='item' &&(benefit.item_id==0 || benefit.item_id==null)){
          alert("Item tidak boleh kosong");
          return;
        }
        if(benefit.earn_type=='item' &&(benefit.min_spend_or_bring==0 || benefit.item_id==null)){
          alert("min_spend_or_bring tidak boleh kosong");
          return;
        }
        if(benefit.benefit_type=='' || benefit.benefit_type==null){
          alert("Benefit Type tidak boleh kosong");
          return;
        }
        if(benefit.benefit_value=='' || benefit.benefit_value==null){
          alert("Benefit Value tidak boleh kosong");
          return;
        }
        if(benefit.benefit_type=='voucher' &&(benefit.voucher_type=='' || benefit.voucher_type==null)){
          alert("Voucher Type tidak boleh kosong");
          return;
        }
        if(benefit.benefit_type=='voucher' && benefit.voucher_type=='percent' && this.myService.removeSeparator(benefit.benefit_value)>100){
          alert("Voucher tidak boleh lebih dari 100%");
          return;
        }
        if(benefit.benefit_type=='voucher' && (benefit.voucher_expired=='' || benefit.voucher_expired==null || benefit.voucher_expired_type==0 || benefit.voucher_expired_type==null)){
          alert("Voucher Expired tidak boleh kosong");
          return;
        }
        if (
          (benefit.earn_type == "birthday" || benefit.earn_type == "welcome") &&
          (benefit.email_template == "" || benefit.email_template==null)
        ) {
          alert("Email Template tidak boleh kosong");
          return;
        }
        
        tierData.benefit[i].maximum_voucher_value = this.myService.removeSeparator(tierData.benefit[i].maximum_voucher_value);
        tierData.benefit[i].voucher_min_spend = this.myService.removeSeparator(tierData.benefit[i].voucher_min_spend);
        tierData.benefit[i].benefit_value = this.myService.removeSeparator(tierData.benefit[i].benefit_value);
        tierData.benefit[i].min_spend_or_bring = this.myService.removeSeparator(tierData.benefit[i].min_spend_or_bring);
        tierData.benefit[i].min_transactions = this.myService.removeSeparator(tierData.benefit[i].min_transactions);
      }
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "action":this.action,
        "id":this.tierId,
        "tier_name":tierData.tierName ?  tierData.tierName : '',
        "spend_to_reach" : spendToReach ,
        "spend_to_keep":spendToKeep,
        "redeemPercent":tierData.redeemPercent ?  tierData.redeemPercent : 0,
        "active_flag":tierData.activeFlag ?  tierData.activeFlag : 'N',
        "username":this.userProfile.username,
        "benefit":tierData.benefit
      };
      this.tierService.saveTier(options)
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        }
        else if(response.status.code === 409) {
          this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });  
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.buildFormTier();
            this.navCtrl.navigateForward(['/tier']);;
          }
        }
      ]
    });
    await alert.present();
  }

    get getDetailArray() {
      return (<FormArray>this.formTier.get('benefit'));
    }
    addBenefit() {
      const detail = this.fb.group({
        benefit_name: [],
        earn_type: [],
        item_id:[],
        custom_earn_start_date:[],//special for custom date
        custom_earn_end_date: [],//special for custom date
        benefit_type: [],
        min_spend_or_bring: [0],
        min_transactions: [0],
        multiple_benefit: ['N'],
        benefit_value: [0],
        voucher_earn_time: [],
        voucher_start:[0],
        voucher_expired: [0],
        voucher_expired_type: [],
        voucher_type:[],
        maximum_voucher_value :[0],
        voucher_min_spend :[0],
        voucher_code :[''],
        email_template :[],
        active_flag :['Y']
      });
      this.getDetailArray.push(detail);
    }
     setMaxDate() {
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      
      // Set the max date to the last day of next year (31 Dec)
      this.maxDate = `${nextYear}-12-31`;
    }

    deleteBenefit(i:any){
      this.getDetailArray.removeAt(i);
    }
    startBeforeEndValidator(group: AbstractControl): ValidationErrors | null {
      const start = group.get('custom_earn_start_date').value;
      const end = group.get('custom_earn_end_date').value;

      if (!start || !end) return null;
        const startDate = new Date(start);
        const endDate = new Date(end);

        // Buang waktu: ambil hanya YYYY-MM-DD
        const startOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const endOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        return endOnly < startOnly ? { endBeforeStart: true } : null;
    }

}
